import React,{useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import Cookies from 'js-cookie';

function Check_pp({setUpdatepp}) {

       useEffect(()=>{
            const userCookie = Cookies.get('user');

            if(userCookie)
            {
                const loginData = {
                    password: Cookies.get('user')
                };
             
                  
                // Send data to the PHP backend using fetch
                fetch('https://hosteladventures.site/PHP/Updates/Check_PP.php', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(loginData)
                  })
                    .then(response => response.json())
                    .then(data => {
                      // Handle response from backend (e.g., login success or failure)
                      if(data.message=='No Image')
                      {
                        
                        setUpdatepp(true)
                      }
    
                    
                   
                    })
                    .catch(error => {
                      console.error('Error:', error);
                    });
             
            }

    
        },[])

  return (
    <div>
        
    </div>
  )
}

Check_pp.propTypes = {}

export default Check_pp
